import { render, staticRenderFns } from "./banner-text-translations-tab.vue?vue&type=template&id=adc45b86"
import script from "./banner-text-translations-tab.vue?vue&type=script&lang=js"
export * from "./banner-text-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports